import { Component, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { UniqueLogUsersPerDate } from '../model/UniqueLogUsersPerDate';
import { Log } from '@src/app/models/log';
import { AdminService } from '../service/admin.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-uniqueloginchart',
  templateUrl: './uniqueloginchart.component.html',
  styleUrls: ['./uniqueloginchart.component.css']
})
export class UniqueloginchartComponent {
  private root!: am5.Root;
  logs: Log[];
  epochTime: number;
  uniqueLogs: UniqueLogUsersPerDate[];
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private zone: NgZone, private as: AdminService) {}


  // Run the function only in the browser
  browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }
  // countUniqueLogUsersPerDate(logs: Log[]): UniqueLogUsersPerDate[] {
  //   const uniqueLogUsersPerDate: UniqueLogUsersPerDate[] = [];
  //   const logUsersPerDate = new Map<string, Set<string>>(); // Map of date to Set of unique log users

  //   // Iterate through the logs and group log users by date
  //   for (const log of logs) {
  //     const date = log.timeISO.substring(0, 10);
  //     this.epochTime = new Date(date).getTime();
  //    // //console.log(this.epochTime); //
  //    // if (!logUsersPerDate.has(date)) {
  //       logUsersPerDate.set(date, new Set<string>());
  //      // logUsersPerDate.set(epochTime.toString(), new Set<string>());
  //    // }
  //     logUsersPerDate.get(date)?.add(log.loguser);
  //   }

  //   // Iterate through the grouped log users and count the number of unique users per date
  //   for (const [logDate, users] of logUsersPerDate) {
  //     uniqueLogUsersPerDate.push({
  //       date: (new Date(logDate).getTime()),
  //       value: (users.size),
  //     });
  //   }

  //   return uniqueLogUsersPerDate;
  // }
  countUniqueLogUsersPerDate(logs: Log[]): UniqueLogUsersPerDate[] {
    const uniqueLogUsersPerDate: UniqueLogUsersPerDate[] = [];
    const logUsersPerDate = new Map<string, Set<string>>(); // Map of date to Set of unique log users
  
    const today = new Date();
    const last30Days = new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000); // 30 days including today
  
    // Filter logs to only include those within the last 30 days
    const filteredLogs = logs.filter((log) => {
      const logDate = new Date(log.timeISO.substring(0, 10));
      return logDate >= last30Days && logDate <= today;
    });
  
    // Group log users by date
    for (const log of filteredLogs) {
      const date = log.timeISO.substring(0, 10); // Extract the date portion (YYYY-MM-DD)
      if (!logUsersPerDate.has(date)) {
        logUsersPerDate.set(date, new Set<string>());
      }
      logUsersPerDate.get(date)?.add(log.loguser);
    }
  
    // Populate the result for the last 30 days
    for (let i = 0; i < 30; i++) {
      const date = new Date(today.getTime() - i * 24 * 60 * 60 * 1000); // Calculate the date
      const dateString = date.toISOString().substring(0, 10); // Format the date as YYYY-MM-DD
  
      uniqueLogUsersPerDate.push({
        date: date.getTime(), // Timestamp for the date
        value: logUsersPerDate.get(dateString)?.size || 0, // Count unique users or 0 if no logs
      });
    }
  
    return uniqueLogUsersPerDate.reverse(); // Reverse to have oldest date first
  }
  
  ngAfterViewInit() {
    // Chart code goes in here
 //   //console.log('Chart Initialized');
    var from = new Date();
    from.setDate(from.getDate() - 30);
    var to = new Date();
    this.as.getLogs(from.toISOString(), to.toISOString()).pipe(untilDestroyed(this)).subscribe(data => {
      this.logs = data;
     // //console.log('Logs Data', data);
      for (var log of this.logs) {
        if (sessionStorage.getItem('person_' + log.loguser)) {
          log.loguser = JSON.parse(sessionStorage.getItem('person_' + log.loguser)).fullname;

        } else {
          this.as.getPerson(log.loguser).pipe(untilDestroyed(this)).subscribe(person => {
            sessionStorage.setItem('person_' + log.loguser, JSON.stringify(person));
            log.loguser = person.fullname;
          });
        }
      }
      this.uniqueLogs = this.countUniqueLogUsersPerDate(this.logs);
     // //console.log('Unique LogIns Per date: ', this.uniqueLogs);
      this.plotChart();
    });

  }
  plotChart(){
    this.browserOnly(() => {
      let root = am5.Root.new("chartdiv");

      root.setThemes([am5themes_Animated.new(root)]);

      let chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panY: false,
          wheelY: "zoomX",
          layout: root.verticalLayout,
          maxTooltipDistance: 0
        })
      );

      // Define data
      let datas = this.uniqueLogs;
      let modData = [
      { date: 1685491200000, value: 100},
      { date: 1685577600000, value: 180},
      { date: 1685664000000, value: 150},
      { date: 1685923200000, value: 100}
      ];
      let data = [{
        date: new Date(2021, 0, 1).getTime(),
        value: 100
      }, {
        date: new Date(2021, 0, 2).getTime(),
        value: 320
      }, {
        date: new Date(2021, 0, 3).getTime(),
        value: 270
      }, {
        date: new Date(2021, 0, 4).getTime(),
        value: 150
      }, {
        date: new Date(2021, 0, 5).getTime(),
        value: 156
      }, {
        date: new Date(2021, 0, 6).getTime(),
        value: 199
      }, {
        date: new Date(2021, 0, 7).getTime(),
        value: 114
      }, {
        date: new Date(2021, 0, 8).getTime(),
        value: 320
      }, {
        date: new Date(2021, 0, 9).getTime(),
        value: 90
      }, {
        date: new Date(2021, 0, 10).getTime(),
        value: 300
        }, {
        date: new Date(2021, 0, 11).getTime(),
        value: 150
      }, {
        date: new Date(2021, 0, 12).getTime(),
        value: 320
      }, {
        date: new Date(2021, 0, 13).getTime(),
        value: 185
      }, {
        date: new Date(2021, 0, 14).getTime(),
        value: 100
        }];
     // //console.log('Chart Data', data);
     // //console.log('Our Data', this.uniqueLogs);


var yAxis = chart.yAxes.push(
  am5xy.ValueAxis.new(root, {
    extraTooltipPrecision: 1,
    renderer: am5xy.AxisRendererY.new(root, {})
  })
);

let xAxis = chart.xAxes.push(
  am5xy.DateAxis.new(root, {
          baseInterval: { timeUnit: "day", count: 1 },
          renderer: am5xy.AxisRendererX.new(root, {})
        })
      );

      xAxis.get("dateFormats")["day"] = "MM/dd";
      xAxis.get("periodChangeDateFormats")["day"] = "MMM";

function createSeries(name, field) {
  var series = chart.series.push(
    am5xy.LineSeries.new(root, {
      name: name,
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: field,
      valueXField: "date",
      tooltip: am5.Tooltip.new(root, {}),
      connect: false
    })
  );

  series.bullets.push(function() {
    return am5.Bullet.new(root, {
      sprite: am5.Circle.new(root, {
        radius: 5,
        fill: series.get("fill")
      })
    });
  });
  series.strokes.template.set("strokeWidth", 2);
  series.get("tooltip").label.set("text", "[bold]{name}[/]\n{valueX.formatDate()}: {valueY}")
  series.data.setAll(datas);
}

      createSeries("Unique Logins", "value");
    //  createSeries("Unique Logins", "uniqueUsers");

chart.set("cursor", am5xy.XYCursor.new(root, {
  behavior: "zoomXY",
  xAxis: xAxis
}));

xAxis.set("tooltip", am5.Tooltip.new(root, {
  themeTags: ["axis"]
}));

yAxis.set("tooltip", am5.Tooltip.new(root, {
  themeTags: ["axis"]
}));
      let legend = chart.children.push(am5.Legend.new(root, {}));
      legend.data.setAll(chart.series.values);
      this.root = root;
    });// end of browser if

  }
  ngOnDestroy() {
    this.browserOnly(() => {
      if (this.root) {
        this.root.dispose();
      }
    });
  }
}

